export const GET_REPORTS_FILTERS = 'providers/reports/ReportsFilters/GET_REPORTS_FILTERS';
